import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { AdminConsumerStatsState } from "../../models/mp-admin/consumer-stats-state";

const initialState: AdminConsumerStatsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumerStats.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.consumerStats.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function consumerStatsReducer(
	state: AdminConsumerStatsState | undefined,
	action: Action
): AdminConsumerStatsState {
	return reducer(state, action);
}
